import React, { useRef } from "react";
// import Autocomplete from "react-google-autocomplete";
import { useJsApiLoader, Autocomplete } from "@react-google-maps/api";

const MapKey =
  process.env.REACT_APP_GOOGLE_MAP_KEY ||
  "AIzaSyDYENkK5g10o0FwB1aYjcYXOs_WEXv3IbM";

const AutocompleteLocations = ({
  form,
  SetpickupDetails = () => {},
  ...props
}) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: MapKey,
    libraries: ["places"],
  });
  const autocompleteRef = useRef(null);
  const handleLoad = (autocomplete) => {
    // console.log("Autocomplete loaded:", autocomplete);
    autocompleteRef.current = autocomplete;
  };

  const handlePlaceSelect = () => {
    const place = autocompleteRef.current.getPlace();
    if (place.geometry && place.geometry.location) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      // console.log("Latitude:", lat);
      // console.log("Longitude:", lng);
      SetpickupDetails({ lat, lng });
    }
    if (place && place.formatted_address) {
      // console.log("place?.formatted_address", place?.formatted_address);
      form.setFieldValue("Location", place?.formatted_address);
    }
    // console.log("Selected place:", place);
  };

  return (
    <>
      {isLoaded && (
        <Autocomplete onLoad={handleLoad} onPlaceChanged={handlePlaceSelect}>
          <input type="text" />
        </Autocomplete>
      )}
    </>
  );
};

export default AutocompleteLocations;
